<template>
  <div class="main" id="main">
    <div class="RankheaderBox">
      <van-nav-bar class="title" :title="state.matchInfo.matchName">
        <template #left >
          <van-icon name="arrow-left" size="18"  color="#fff" @click="backFun()"/>
        </template>
        <template #right >
          <van-icon name="description" size="18"  color="#fff" @click="showPopup()"/>
        </template>
      </van-nav-bar>
    </div>
    <van-popup class='showPopup' v-model:show="show"  position="right">
      <div class="matchInfo">
        <div class="popMatchName">{{state.matchInfo.matchName}}</div>
        <div class="popMatchTime">{{state.matchInfo.startDate}}</div>
        <div class="popMatchTime">{{state.projectInfo.groupName}}</div>
      </div>
      <!-- <div v-else>
        <div class="popMatchName">{{state.matchInfo.matchName}}</div>
        <div class="popMatchno">暂无数据</div>
      </div> -->
      <!-- 侧滑弹窗 -->
      <div class="matchName" v-for="(data, idx) in state.pdfmatchList" :key="idx" @click="goPDFFun(data)" >
       <div class="pdf">{{data.name}}</div>
      </div>
    </van-popup>
    <div class="matchList">
      <!-- <van-tabs v-model:active="state.active" animated @click-tab="onClickTab"> -->
      <van-tabs v-model:active="state.active" animated @click-tab="onClickTab">
        <van-tab v-for="(data,index) in groupList.value" :title="data" :key="index" :name="data">
          <van-collapse v-model="state.ProActive" accordion>
            <van-collapse-item class="projectName" @click="changeProFun(index)" v-for="(item,index) in projectList.value" :key="index" :title="item[0]" :name="index">
              <div class="matchName" v-for="(data, idx) in filterliveMenuByPrjoect(state.active,item[0])" :key="idx" @click="goProjectFun(data,state.active,item[0],0)" >
                <div class="borderBox ">
                  <div class="projectBox">
                    <span>{{data.matchType}}-{{data.groupNo}}组&nbsp;{{data.startTime}}</span>
                  </div>
                  <div class="pdfbox" v-if="showpdfFun(data)" @click.stop="goProjectFun(data,state.active,item[0],1)" >
                    <van-icon  name="description" color="#ee0a24"/>
                  </div>
                  <!-- <van-icon name="wap-nav" /> -->
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
//projectScreenType //1宣传页，2靶位展示，3运动员介绍，4成绩展示，5排名结果展示
import { ref, computed, reactive, toRefs } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
var opt;
export default {
  setup() {
    const data = reactive(createState);
    console.log(data)
    const router = useRouter();
    data.selectedMatchId = router.currentRoute.value.query.selectedMatchId;
    const dataRef = toRefs(data);
    const projectList = data.projectList
    const groupList = data.groupList
    function goFun(url, topicData) {
      router.push({
        path: url,
        query: topicData
      });
    }
    return {
      state: reactive(createState),
      Paho: Paho,
      goFun,
      client: ref({}),
      menuList: ref([]),
      projectList,
      groupList,
      style: ref("0"), // 0 代表请求比赛 1 代表请求项目
      show:ref(false),
    };
  },
  methods: {
    //判断是否展示pdf图标
    showpdfFun(data){
      console.log(data)
      for(var i=0;i<this.state.pdfprojectList.length;i++){
          const d = this.state.pdfprojectList[i]
        if(d.FileType==2001&&d.MatchProjectid==data.projectId&&d.MatchType==data.matchStage){
          return true
        }
      }
      return false
    },
    goPDFFun(data){
      // location.href = data.FileUrl
      // window.open(data.FileUrl) 
      this.$router.push({name:'pdf',query:{url:data.FileUrl}});
    },
    showPopup () {
      this.show = true;
    },
    backFun(){
      
      const topicData = {
        selectedMatchId:this.state.selectedMatchId,
      };
      
      this.$router.push({
        path: "/",
        query: topicData
      });
    },
    //选择项目手风琴
    changeProFun(data){
      this.state.ProActive = data
    },
    //点击项目阶段
    goProjectFun(data,group,idx,num) {
      console.log(data)
      //判断是否有PDF文件
      if(num==0){
        console.log('暂无pdf')
        this.state.propshowData = this.filterliveMenuByPrjoect(group,idx)
        this.style = "1";
        const topicData = {
          projectTopic: data.topic
        };
        //将请求的topic赋值到公共参数中
        if(this.state.projectTopic!=''){
          this.state.client.unsubscribe(
            this.state.projectTopic,
            {
            onSuccess:(msg)=>{
                console.info("成功取消："+this.state.projectTopic);
                this.state.projectTopic = data.topic;
                this.state.client.subscribe(data.topic); //订阅监控通用指令
                console.info("订阅："+this.state.projectTopic);
            },
            onFailure:(err)=>{
              console.log("取消订阅失败:" + err);
            }
            }
          );
        }else{
          this.state.projectTopic = data.topic;
          this.state.client.subscribe(data.topic); //订阅监控通用指令
        }
      }else if(num==1){
        for(var i=0;i<this.state.pdfprojectList.length;i++){
          const d = this.state.pdfprojectList[i]
          //判断文件类型 项目id 项目阶段
          if(d.FileType==2001&&d.MatchProjectid==data.projectId&&d.MatchType==data.matchStage){
            console.log('跳转到pdf文件')
            this.$router.push({name:'pdf',query:{url:d.FileUrl}});
            return
          }
        }
      }else{
      }
      
    },
    //切换组别
    onClickTab(title) {
      this.state.active =title.title
      this.state.ProActive = 0
      this.projectList.value = this.arrMatchProject(title.title);
      console.log(this.state)
    },
    topicFun() {
      const MQTT_TOPIC = this.state.matchTopic;
      this.client.subscribe(MQTT_TOPIC); //订阅监控通用指令
    },
    // 处理select筛选后的数组
    selectedLiveMenu() {
      return this.state.matchList.value.menuList.filter(match => {
       
        if(match.matchId == this.state.selectedMatchId){
           this.state.matchInfo = match
        }
        return match.matchId == this.state.selectedMatchId;
      });
    },
    // 获取所有年份
    arrMatchYear() {
      let arr = [];
      this.menuList.value.forEach(item => {
        if (arr.indexOf(item.matchYear) == -1) {
          arr.push(item.matchYear);
        } else {
          return false;
        }
      });
      return arr.sort().reverse();
    },
    // 获取所有组别
    arrMatchGroup() {
      let arr = [];
      this.selectedLiveMenu().forEach(item => {
        if (arr.indexOf(item.matchGroupName) == -1) {
          arr.push(item.matchGroupName);
        } else {
          return false;
        }
      });
      return arr;
    },
    // 获取所有项目
    arrMatchProject(title) {
      let arr = [];
      this.filterliveMenuByGroup(title).forEach(item => {
        let add = true;
        arr.forEach(arrItem => {
          if (arrItem[0] == item.projectName) {
            add = false;
            return false;
          } else {
            return false;
          }
        });
        if (add) {
          arr.push([item.projectName, item.topic]);
        }
      });
      return arr;
    },
    // 2根据组别筛选比赛
    filterliveMenuByGroup(group) {
      return this.selectedLiveMenu().filter(item => {
        return item.matchGroupName == group;
      });
    },
    // 3根据组别和项目筛选项目类别
    filterliveMenuByPrjoect(group, project) {
      const data =  this.filterliveMenuByGroup(group)
        .filter(item => {
          return item.projectName == project;
        })
        .sort((a, b) => {
          // console.log(a.startTime.replace(/-/g,'/'))
          const aTime = a.startTime.replace(/-/g,'/')
          const  bTime =b.startTime.replace(/-/g,'/')
          if(aTime==bTime){
            if(a.groupNo=='all'){
              return 1
            }else{
              return -1
            }
          }
          return new Date(a.startTime.replace(/-/g,'/')) - new Date(b.startTime.replace(/-/g,'/'));
        });
        // console.log(data)
        return data
    },
    //对相同阶段的组别进行排序
    filterliveMenuBygroupNoFun(data){
      // this.filterliveMenuByPrjoect()
      data.filter(item => {
        return item.matchType=="资格赛"
      //  if(){
      //     if(item.groupNo=='all'){
      //       item.num=999
      //     }else{
      //       item.num =parseFloat(item.groupNo) 
      //     }
      //  }
      })
      console.log(data.filter(item=>{return item.matchType=="资格赛"}))
      return function(a,b){
        var value1 = a.num
        var value2 = b.num
        return value1-value2
      }
    }
  },
  mounted() {
      
  },
  created() {
    //在修改保龄球代码时发现此处因请求数据为相应到时undefined报错 注释后因store数据为响应式会因数据改变自动计算 注销此处代码 2023/6/1
      // this.state.groupList.value = this.arrMatchGroup();
      // this.state.ProActive = 0
      // this.state.active = this.state.groupList.value[0]
      // this.projectList.value = this.arrMatchProject(this.state.active);
      // console.log(this.state)
    //在修改保龄球代码时发现此处因请求数据为相应到时undefined报错 注释后因store数据为响应式会因数据改变自动计算 注销此处代码 2023/6/1
  },
  computed: {}
};
</script>

<style lang="less" scoped>
.pdf{
  width: 80%;
  height: 0.8rem;
  margin: 0 auto;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  background: #4fc5f3;
  font-size: 0.4rem;
  margin-top: 0.2rem;
  border-radius: 5px;
}
.popMatchName{
  width: 100%;
  height: 0.8rem;
  text-align: center;
  font-size: 0.4rem;
  background: #39a9ed;
  line-height: 0.8rem;
  color: #fff;
  overflow: hidden;
}
.popMatchno{
  width: 100%;
  height: 0.8rem;
  text-align: center;
  font-size: 0.4rem;
  line-height: 0.8rem;
  overflow: hidden;
}
/deep/.showPopup{
  width: 70%;
  height: 100%;
  background: #fff;
  .propBox{
    width: 100%;
    height: 1rem;
    border-bottom: 1px solid #eee;
    line-height: 1rem;
    .matchTypeName{
      width: 90%;
      float: left;
      text-indent: 6px;
      font-size: 0.36rem;
      font-weight: 700;
    }
  }
}
.RankheaderBox {
  width: 100%;
  height: 1rem;
  position: fixed;
  background: #fff;
  overflow: hidden;
  z-index: 10;
  .projectBox{
    height: 0.8rem;
    line-height: 0.8rem;
    font-weight: 700;
    text-align: center;
    font-size: 0.4rem;
  }
  .title{
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis{
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
      height: 100%;
      line-height: 1rem
    }
    /deep/.van-nav-bar__content{
      height: 100%;
    }
  }
  
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  .title {
    /deep/.van-ellipsis {
      color: #fff;
      max-width: 80%;
    }
  }
  // height: 5rem;
}
.my-swipe .van-swipe-item {
  height: 4rem;
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
  img {
    width: 100%;
    height: 4rem;
  }
}
.matchList {
  // flex: 1;
  height: auto;
  width: 100%;
  background: #fff;
  margin-top:1rem;
 /deep/.van-cell__title{
   span{
     font-size: 0.4rem;
     font-weight: 700;
     color: #fff;
   }
   
 }
}
/deep/.van-cell{
    background: linear-gradient(170deg,#adff2f,#4fc5f3,#1f95d3);
}
/deep/.van-icon{
  color: #fff;
}
/deep/.van-collapse-item__content{
    width: 100%;
    height: 100%;
    .matchName {
      font-weight: 700;
      width: 100%;
      height: 1rem;
      text-align: left;
      line-height: 1rem;
      font-size: 0.3rem;
      .borderBox {
        width: 92%;
        height: 1rem;
        margin-left: 8%;
        // border-bottom: 1px solid #333;
      }
      .projectBox {
        width: 80%;
        height: 1rem;
        box-sizing: border-box;
        display: inline-block;
        word-break: keep-all; /* 不换行 */
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
        text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
        float: left;
      }
      .pdfbox{
        width: 15%;
        float: left;
        text-align: center;
      }
      .icon {
        width: 0.2rem;
        height: 1rem;
        line-height: 1rem;
        float: left;
      }
    }
}

</style>